module.exports = __webpack_public_path__ + "static/assets/10418705f2a8e00859ff30ef1edeb1e3.svg";